import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { Ds2ExperimentData } from 'src/app/shared/hooks/ds2Experiment';
import { FCM_EXPERIMENT_DS2 } from 'src/app/shared/hooks/ds2Experiment';
import { getExperimentName } from 'src/app/shared/hooks/experiment';

const { fcmConfigs, isEnabled, experimentName } = FCM_EXPERIMENT_DS2;

export const getDs2ExperimentUserData = async (
	utilityContext: UtilityContext,
	{ countryCode, locale }: { countryCode: string; locale: string },
): Promise<Ds2ExperimentData> => {
	try {
		const fcm = await utilityContext.fcm.get(fcmConfigs);

		const callbackContext = {
			fcm,
			locale,
			countryCode,
		};

		const getVariation = async (name: string) => {
			const experiment = utilityContext.experiments.get(name);
			await experiment.treat();
			return experiment.variation;
		};

		const fcmEnabled = isEnabled(callbackContext);
		const name = getExperimentName(callbackContext, experimentName);

		return {
			ds2FcmExperiment: {
				fcm,
				fcmEnabled,
				name,
				variation: fcmEnabled && name ? await getVariation(name) : 'control',
			},
		};
	} catch (e) {
		void utilityContext.errorReporter.report({
			error: new Error('Failed to get decision maker profile user experiment data'),
		});

		return {
			ds2FcmExperiment: {
				fcm: { config: undefined },
				fcmEnabled: false,
				name: undefined,
				variation: 'control',
			},
		};
	}
};
